export default {
  namespaced: true,
  state: {
    validations: {},
    permissionError: null,
    networkError: null,
    globalError: null,
  },
  getters: {
    hasValidationErrors: (state) => Object.keys(state.validations).length > 0,
    hasPermissionError: (state) => !!state.permissionError,
    hasNetworkError: (state) => !!state.networkError,
    hasGlobalError: (state) => !!state.globalError,
    getValidationError: (state) => (field) => state.validations[field] || null,
  },
  mutations: {
    setValidationError(state, error) {
      state.validations = error || {}
    },
    setPermissionError(state, error) {
      state.permissionError = error
    },
    setNetworkError(state, error) {
      state.networkError = error
    },
    setGlobalError(state, error) {
      state.globalError = error
    },
    clearAllErrors(state) {
      state.validations = {}
      state.permissionError = null
      state.networkError = null
      state.globalError = null
    },
    clearValidationErrors(state) {
      state.validations = {}
    },
    clearPermissionError(state) {
      state.permissionError = null
    },
    clearNetworkError(state) {
      state.networkError = null
    },
  },
  actions: {
    clearAll({ commit }) {
      commit('clearAllErrors')
    },
    setError({ commit }, { type, error }) {
      switch (type) {
        case 'validation':
          commit('setValidationError', error)
          break
        case 'permission':
          commit('setPermissionError', error)
          break
        case 'network':
          commit('setNetworkError', error)
          break
        default:
          commit('setGlobalError', error)
      }
    },
  },
}
